/*
  Minti card slides: flick through product images on collection cards.
  - Desktop: arrows show on hover. Touch: swipe left/right on the image.
  - Listeners are delegated from document, so cards appended by infinite
    scroll work without re-initialising.
  - A card's extra images only load once someone hovers an arrow or swipes.
  Markup: snippets/minti-card-slides.liquid
*/
(function () {
  var SWIPE_MIN = 40;
  var DRAG_SLOP = 10;

  function maskFor(el) {
    var mask = el && el.closest ? el.closest('.grid-product__image-mask') : null;
    return mask && mask.querySelector('[data-minti-slides]') ? mask : null;
  }

  function loadImages(mask) {
    if (mask.hasAttribute('data-minti-loaded')) return;
    mask.setAttribute('data-minti-loaded', '');

    var imgs = mask.querySelectorAll('[data-minti-slides] img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].srcset = imgs[i].getAttribute('data-srcset');
      imgs[i].src = imgs[i].getAttribute('data-src');
    }
  }

  function go(mask, step) {
    var slides = mask.querySelectorAll('.minti-card-slides__slide');
    var dots = mask.querySelectorAll('.minti-card-dots__dot');
    var total = slides.length + 1; // slide 0 is the card's own featured image
    var current = parseInt(mask.getAttribute('data-minti-index') || '0', 10);
    var next = (current + step + total) % total;

    loadImages(mask);
    mask.setAttribute('data-minti-index', next);

    for (var i = 0; i < slides.length; i++) {
      slides[i].classList.toggle('is-active', i === next - 1);
    }
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-active', j === next);
    }
  }

  document.addEventListener('mouseover', function (e) {
    var btn = e.target.closest && e.target.closest('[data-minti-prev], [data-minti-next]');
    var mask = btn ? maskFor(btn) : null;
    if (mask) loadImages(mask);
  });

  // Capture phase, so the card link (and Motion's page transition handler)
  // never sees an arrow click or the click that follows a swipe.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var btn = e.target.closest('[data-minti-prev], [data-minti-next]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var mask = maskFor(btn);
      if (mask) go(mask, btn.hasAttribute('data-minti-next') ? 1 : -1);
      return;
    }

    var link = e.target.closest('.grid-product__link');

    // A press that started on an arrow but was released just off it (the
    // mouse moved a little) still counts as that arrow, as long as it ends on
    // the same card.
    if (e.detail > 0 && pressedArrow && link && link.contains(pressedArrow)) {
      e.preventDefault();
      e.stopPropagation();
      go(maskFor(pressedArrow), pressedArrow.hasAttribute('data-minti-next') ? 1 : -1);
      pressedArrow = null;
      return;
    }

    if (link && link.hasAttribute('data-minti-swiped')) {
      e.preventDefault();
      e.stopPropagation();
      link.removeAttribute('data-minti-swiped');
      return;
    }

    // A mouse press on the photo that moved more than a nudge is a drag, not
    // a click: don't open the product, and a sideways drag flicks the photo
    // like a swipe does on touch.
    // (e.detail is 0 for keyboard-triggered clicks, which have no drag.)
    // Released anywhere on the same card counts (the click then lands on the link).
    if (e.detail > 0 && pressedMask && link && link.contains(pressedMask)) {
      var dx = e.clientX - pressX;
      var dy = e.clientY - pressY;
      if (Math.abs(dx) > DRAG_SLOP || Math.abs(dy) > DRAG_SLOP) {
        e.preventDefault();
        e.stopPropagation();
        if (Math.abs(dx) >= SWIPE_MIN && Math.abs(dx) > Math.abs(dy)) {
          go(pressedMask, dx < 0 ? 1 : -1);
        }
      }
    }
  }, true);

  // The arrows sit inside the card link, so pressing an arrow (or the photo)
  // and moving the mouse slightly starts a native link drag, which shows the
  // link preview and swallows the click. Block drags that start on a card
  // image area; the title link below stays draggable.
  var pressedMask = null;
  var pressedArrow = null;
  var pressX = 0;
  var pressY = 0;

  document.addEventListener('mousedown', function (e) {
    pressedMask = maskFor(e.target);
    pressedArrow = e.target.closest ? e.target.closest('[data-minti-prev], [data-minti-next]') : null;
    pressX = e.clientX;
    pressY = e.clientY;
  }, true);

  document.addEventListener('dragstart', function (e) {
    if (pressedMask) e.preventDefault();
  }, true);

  var touchMask = null;
  var startX = 0;
  var startY = 0;

  document.addEventListener('touchstart', function (e) {
    touchMask = e.touches.length === 1 ? maskFor(e.target) : null;
    if (!touchMask) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!touchMask) return;
    var mask = touchMask;
    touchMask = null;

    var touch = e.changedTouches[0];
    var dx = touch.clientX - startX;
    var dy = touch.clientY - startY;
    if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy)) return;

    go(mask, dx < 0 ? 1 : -1);

    var link = mask.closest('.grid-product__link');
    if (link) {
      link.setAttribute('data-minti-swiped', '');
      setTimeout(function () { link.removeAttribute('data-minti-swiped'); }, 400);
    }
  }, { passive: true });
})();
